import { render } from "./CollectionCardGodBull.vue?vue&type=template&id=710ec808"
import script from "./CollectionCardGodBull.vue?vue&type=script&lang=js"
export * from "./CollectionCardGodBull.vue?vue&type=script&lang=js"

import "./CollectionCardGodBull.vue?vue&type=style&index=0&id=710ec808&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__